import { motion } from "framer-motion";
import { SANS_2, UI_BODY_SEMIBOLD_SM_DF, icons } from "oolib";
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { usePlatformBuilderContext } from "../../../../../../../contexts/platformBuilderContext";
import { __CheckAccessViaConfig } from "../../../../../../../utils/accessControl";
import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";
import { DropdownSingle } from "oolib";
import { useIsThisLinkActive } from "../../utils/useIsThisLinkActive";
import { StyledCustomSelect, StyledLinkWrapper } from "./styled";
import { RotatingCaret } from "../../../../../../generalUI/RotatingCaret";
import { useHeaderHeight } from "@/CONSTANTS";
const { CaretDown } = icons;



export const PRIMMenu = ({
  options: _options, // can be a location obj or a string
  display,
  id,
  builderProps, //if exists means header is being rendered in NavBuilder
  accessControl, //this is folder level access control
  useFixedWidth = false,
  maxWidth = 100,
}) => {
  const { user } = useGetQueryData("userData") || {};
  const { inGlobalNavBuilder } = usePlatformBuilderContext();
  
  const headerHeight = useHeaderHeight();
  //access control

  if (accessControl && !__CheckAccessViaConfig({ ...accessControl, user })) return null;

  const options = _options.filter((op) => {
    return (
      op.dontRender !== true && //dontRender will be true if in genLinksConfigsAsOptions > checkAccessAndGenContentPageLinkProps, the access is denied
      (!op.accessControl || //allow if check doesnt exist
        __CheckAccessViaConfig({ ...op.accessControl, user })) //OR allow if check says its allowed
    );
  });

  const { getActiveMenuOption } = useIsThisLinkActive();

  const navigate = useNavigate();

  const handleChange = (k, v) => {
    !inGlobalNavBuilder && navigate(v.to);
  };
  const activeMenuOption = getActiveMenuOption({ options });

  const [showOptions, setShowOptions] = useState(undefined);

  if (!builderProps && options.length === 0) return null;
  // console.log({ useFixedWidth, maxWidth })
  return (
    <div style={{ height: "inherit" }} id={id}>
      <DropdownSingle
        id={id}
        disableSelectTextUpdate
        value={activeMenuOption}
        options={options}
        onChange={(key, value) => handleChange(id, value)}
        optionsClassName={"UI_BODY_SEMIBOLD_SM_DF"}
        broadcastShowOptions={(showOptions) => setShowOptions(showOptions)}
        genCustomSelectComp={() => {
          return (
            <StyledCustomSelect isActive={!!activeMenuOption} headerHeight={headerHeight} useFixedWidth={useFixedWidth} maxWidth={maxWidth}>
                <StyledLinkWrapper useFixedWidth={useFixedWidth} maxWidth={maxWidth}>{display}</StyledLinkWrapper>
                <RotatingCaret iconSize={16} position={showOptions ? 'up' : 'down'}/>
            </StyledCustomSelect>
          );
        }}
      />
    </div>
  );
};
